import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('htag faa', data)
  if (data?.data?.status === 'SUCCESS') {
    return data?.data
  } else {
    throw data
  }
}

const manageSRQsApi = ({ 'SQR TR NO': deviceId, mid, 'VB DSN': linkedDeviceId }, action) => {
  console.log('actuons', action)
  const request: JFSRequest<{}> = {
    apiPath: action === 'Pair' ? getUrl(APIEndPoints.linkSQrs) : getUrl(APIEndPoints.delinkSQRs),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: action === 'Pair' ? { deviceId, mid, linkedDeviceId } : { deviceId, mid },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      console.log('htag errr', error)
      throw error
    })
}

export { manageSRQsApi }
